module.exports = __webpack_public_path__ + "assets/img/20_310_big.8966ea6e.jpg";